import { isMobile } from 'Library/helpers/mobile';

if (!isMobile()) {
    document
        .querySelectorAll<HTMLElement>('.icon--item[data-icon_type="animated-icon"]')
        .forEach(item => {
            item.querySelectorAll<HTMLImageElement>('img:not(.static-image)').forEach(img => {
                const pngUrl = img.dataset.src;
                const gifUrl = item.dataset.gif;

                item.addEventListener('mouseenter', () => {
                    if (gifUrl) {
                        img.src = gifUrl;
                        img.srcset = gifUrl;
                        img.onload = () => img.classList.add('pd-none');
                    }
                });
                item.addEventListener('mouseleave', () => {
                    if (pngUrl) {
                        img.src = pngUrl;
                        img.srcset = pngUrl;
                        img.onload = () => img.classList.remove('pd-none');
                    }
                });
            });
        });
}
